module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/bago2023',
    profileColor: {saturation: 80, brightness: 50},
    favicon: 'bagofavicon.ico',
    defaultPassword: 'default'
}